import "react-loading-skeleton/dist/skeleton.css";
import Reservations from "./Reservations";

const CancelReservations = () => {
  return (
    <>
      <Reservations status="cancelled" />
    </>
  );
};

export default CancelReservations;
